import Text from "antd/es/typography/Text"
import { type CSSProperties, type ReactNode } from "react"

import Flex from "#blocks/Flex"

import CheckboxWrapper from "./CheckboxWrapper"

const CheckboxContentBlock = ({
  title,
  fieldName,
  description,
  children,
  style,
}: {
  title: string
  fieldName: string | string[]
  description: string | ReactNode
  children?: ReactNode
  style?: CSSProperties
}) => {
  return (
    <Flex col style={{ ...style }}>
      <CheckboxWrapper name={fieldName} label={title} />
      <Flex col style={{ marginLeft: 30 }}>
        <Text style={{ marginBottom: 10 }}>{description}</Text>
        {children}
      </Flex>
    </Flex>
  )
}

export default CheckboxContentBlock
